import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);
import egoRouter1 from "./egoRouter1.js"
import egoRouter2 from "./egoRouter2.js"


//问卷
const questionnaire = r =>
  require.ensure([], () => r(require("@/pages/policyEscrow/questionnaire")), "questionnaire");

//问卷托管
const questionplan = r =>
  require.ensure([], () => r(require("@/pages/policyEscrow/questionplan")), "questionplan");

//产品对比
const questioncomp = r =>
  require.ensure([], () => r(require("@/pages/policyEscrow/questioncomp")), "questioncomp");

// 代理人
const agent = r =>
  require.ensure([], () => r(require("@/pages/agent/agentService")), "agent");
// 代理人保费测算
const agentMc = r =>
  require.ensure([], () => r(require("@/pages/agent/agentServiceMc")), "agentMc");
//预约完成
const completed = r =>
  require.ensure([], () => r(require("@/pages/completed")), "completed");
//新预约完成
const ncompleted = r =>
  require.ensure([], () => r(require("@/pages/ncompleted")), "ncompleted");
//资源赋能报名
const resource = r =>
  require.ensure([], () => r(require("@/pages/resourceEnlist/enlist.vue")), "resource");
//资源赋能报名
const letter = r =>
  require.ensure([], () => r(require("@/pages/resourceEnlist/letter.vue")), "letter");
//diy配置
const diy = r =>
  require.ensure([], () => r(require("@/pages/diy/diy.vue")), "diy");
//数字化获客赋能系统
const introduction = r =>
  require.ensure([], () => r(require("@/pages/aside/introduction.vue")), "diy");
//获客赋能_培训
const courseRun = r =>
  require.ensure([], () => r(require("@/pages/goToBanner/courseRun")), "courseRun");
//获客赋能_banner视频
const courseVid = r =>
  require.ensure([], () => r(require("@/pages/goToBanner/courseVid")), "courseVid");
//diy2
const diy2 = r =>
  require.ensure([], () => r(require("@/pages/diy/diy2")), "diy2");
//diy3
const diy3 = r =>
  require.ensure([], () => r(require("@/pages/diy/diy3")), "diy3");
//diy4
const diy4 = r =>
  require.ensure([], () => r(require("@/pages/diy/diy4")), "diy4");
//diy5
const diy5 = r =>
  require.ensure([], () => r(require("@/pages/diy/diy5")), "diy5");
//diy6
const diy6 = r =>
  require.ensure([], () => r(require("@/pages/diy/diy6")), "diy6");
//diy7
const diy7 = r =>
  require.ensure([], () => r(require("@/pages/diy/diy7")), "diy7");
//diy8
const diy8 = r => require.ensure([], () => r(require("@/pages/diy/diy8")), "diy8");

//gzh03
const gzh03 = r =>
  require.ensure([], () => r(require("@/pages/agentShare/gzh03")), "gzh03");

// wx0元付费
const wxpay = r =>
  require.ensure([], () => r(require("@/pages/wxPay/pay1")), "wxpay");
// wx下单页
const wxVidPay = r =>
  require.ensure([], () => r(require("@/pages/wxPay/wxVidPay")), "wxVidPay");
// wx跳转页
const jumpPage = r =>
  require.ensure([], () => r(require("@/pages/wxPay/jumpPage")), "jumpPage");

const courseSp = r =>
  require.ensure([], () => r(require("@/pages/goToBanner/courseSp")), "courseSp");

// 老王商务1V1定制 0.1元付费
const oneConsult = r =>
  require.ensure([], () => r(require("@/pages/wxPay/1v1consult")), "1v1consult");
// 老王商务1V1定制 0元免费
const xiaodoumiao = r =>
  require.ensure([], () => r(require("@/pages/wxPay/xiaodoumiao")), "xiaodoumiao");
// 老王商务1V1定制 成功页
const oneSuccess = r =>
  require.ensure([], () => r(require("@/pages/wxPay/1v1success")), "1v1success");


let indexRouterList = [{
  path: "/questionnaire",
  component: questionnaire,
  meta: {
    requireAuth: true,
    title: "调查问卷"
  }
}, {
  path: "/questionplan",
  component: questionplan,
  meta: {
    requireAuth: true,
    title: "保单托管"
  }
},
{
  path: "/questioncomp",
  component: questioncomp,
  meta: {
    requireAuth: true,
    title: "产品对比"
  }
},

{
  path: "/completed",
  component: completed,
  meta: {
    requireAuth: false,
    title: "预约成功"
  }
},
{
  path: "/ncompleted",
  component: ncompleted,
  meta: {
    requireAuth: false,
    title: "预约成功"
  }
},
{
  path: "/agentList",
  component: agent,
  meta: {
    requireAuth: false,
    title: "大童保险咨询"
  }
},
{
  path: "/agentMc",
  component: agentMc,
  meta: {
    requireAuth: false,
    title: "大童保险咨询"
  }
},
{
  path: "/enlist",
  component: resource,
  meta: {
    requireAuth: false,
    title: "资源赋能报名活动"
  }
},
{
  path: "/letter",
  component: letter,
  meta: {
    requireAuth: false,
    title: "资源赋能报名活动"
  }
},
{
  path: "/diy",
  component: diy,
  meta: {
    requireAuth: false,
    isWxData: true,
    title: "大童1v1保险顾问服务"
  }
},
{
  path: "/introduction",
  component: introduction,
  meta: {
    requireAuth: false,
    title: "数字化获客赋能系统"
  }
},
{
  path: "/courserun",
  component: courseRun,
  meta: {
    requireAuth: false,
    isWxData: true,
    title: "大童保险咨询"
  }
},
{
  path: "/courseVid",
  component: courseVid,
  meta: {
    requireAuth: false,
    isWxData: true,
    title: "大童保险咨询"
  }
},
{
  path: "/courseSp",
  component: courseSp,
  meta: {
    requireAuth: false,
    isWxData: true,
    title: "私域流量如何获客与转化"
  }
},
{
  path: "/diy2",
  component: diy2,
  meta: {
    requireAuth: false,
    isWxData: true,
    title: "大童1v1保险顾问服务"
  }
},
{
  path: "/diy3",
  component: diy3,
  meta: {
    requireAuth: false,
    isWxData: true,
    title: "大童1v1保险顾问服务"
  }
},
{
  path: "/diy4",
  component: diy4,
  meta: {
    requireAuth: false,
    isWxData: true,
    title: "大童1v1保险顾问服务"
  }
},
{
  path: "/gzh03",
  component: gzh03,
  meta: {
    requireAuth: false,
    isWxData: true,
    title: "保险方案定制"
  }
},
{
  path: "/diy5",
  component: diy5,
  meta: {
    requireAuth: false,
    isWxData: true,
    title: "大童1v1保险顾问服务"
  }
},
{
  path: "/diy6",
  component: diy6,
  meta: {
    requireAuth: false,
    isWxData: true,
    title: "大童1v1保险顾问服务"
  }
},
{
  path: "/diy7",
  component: diy7,
  meta: {
    requireAuth: false,
    isWxData: true,
    title: "大童1v1保险顾问服务"
  }
},
{
  path: "/diy8",
  component: diy8,
  meta: {
    requireAuth: false,
    isWxData: true,
    title: "大童1v1保险顾问服务"
  }
},
{
  path: "/wxpay",
  component: wxpay,

  meta: {
    requireAuth: false,
    isWxData: true,
    title: "大童保险服务"
  }
},
{
  path: "/wxVidPay",
  component: wxVidPay,
  meta: {
    requireAuth: false,
    isWxData: true,
    title: "大童保险服务"
  }
},
{
  path: "/jumpPage",
  component: jumpPage,
  meta: {
    requireAuth: false,
    isWxData: true,
    title: "大童保险服务"
  }
},
{
  path: "/oneConsult",
  component: oneConsult,
  meta: {
    requireAuth: false,
    isWxData: true,
    title: "大童保险服务"
  }
},
{
  path: "/oneSuccess",
  component: oneSuccess,
  meta: {
    requireAuth: false,
    title: "大童保险服务"
  },

},
{
  path: "/xiaodoumiao",
  component: xiaodoumiao,
  meta: {
    requireAuth: false,
    title: "1对1定制家庭保障方案"
  },
}
]

indexRouterList = indexRouterList.concat(egoRouter1, egoRouter2)

export default new Router({
  mode: "history",
  base: "/ego/",
  routes: indexRouterList
});



// WEBPACK FOOTER //
// ./src/router/index.js